declare const jQuery: any;
const $ = jQuery;

export function init()
{
	fixRequired();
	fixLabelClick();
}

function fixRequired()
{
	$(".wpcf7-form :input[aria-required]").attr("required", "required");
}

function fixLabelClick()
{
	const $labels = $(".wpcf7-list-item-label");

	$labels.each(function eachLabel() {
		const $label = $(this);
		const $parent = $label.parent();
		const $radio = $parent.find("[type=\"radio\"]");
		const $form = $label.closest("form");
		
		if ($radio.length === 1)
		{
			$label
				.css({ cursor: "default" })
				.on("click", e => {
					if ($radio.prop("checked"))
					{
						return;
					}
					const name: string = $radio.attr("name");
					if (!name)
					{
						$radio.prop("checked", true).trigger("change");
						return;
					}
					const selector: string = `input[type="radio"][name="${name}"]:checked`;
					const $checkedRadio = $form.length === 0 ? $(selector) : $form.find(selector);
					$checkedRadio.prop("checked", false).trigger("change");
					$radio.prop("checked", true).trigger("change");
				});
			return;
		}

		const $checkbox = $parent.find("[type=\"checkbox\"]");

		if ($checkbox.length === 1)
		{
			$label
				.css({ cursor: "default" })
				.on("click", e => {
					$checkbox
						.prop("checked", !$checkbox.prop("checked"))
						.trigger("change");
				});
		}
	});
}
